module.exports = __webpack_public_path__ + "static/img/settingup.6d028e9.png";